import React from 'react';
import SortByDropdown from '../../components/SortByDropdown';
import PropTypes from 'prop-types';

class PaginationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.translationUtility = props.translationUtility;
    }

    componentDidMount() {
        require('./PaginationContainer.css');
    }

    render() {
        const {
            paginationViewModel,
            onCurrentSortByChange,
        } = this.props;
        const firstProductNumber = paginationViewModel.CurrentPageIndex * paginationViewModel.CurrentItemsPerPage + 1;
        const lastProductNumber = firstProductNumber + paginationViewModel.CurrentItemsOnPage - 1;
        const resultsSummary = this.translationUtility.translateResourceString("/Search/Pagination/TotalResultsFormat", {
            first: firstProductNumber,
            last: lastProductNumber,
            total: paginationViewModel.ResultsTotal
        })
        return (
            <div className="row category-list-pagination-wrapper">
                <div className="col-12">
                    <div className="pull-right form-inline pagination-dropdown-wrapper">
                        <label className="total-results hidden-sm hidden-xs">
                            {resultsSummary}
                        </label>
                        <SortByDropdown {...paginationViewModel} onCurrentSortByChange={onCurrentSortByChange} />
                    </div>
                </div>
            </div>
        );
    }
};

PaginationContainer.propTypes = {
    paginationViewModel: PropTypes.shape({
        ResultsTotal: PropTypes.number,
        CurrentItemsPerPage: PropTypes.number,
        CurrentPageIndex: PropTypes.number,
        CurrentSortBy: PropTypes.string,
        CurrentItemsOnPage: PropTypes.number
    }),
    onCurrentItemsPerPageChange: PropTypes.func,
    onCurrentSortByChange: PropTypes.func,
    onCurrentPageIndexChange: PropTypes.func,
    onShowMobileFacetsChange: PropTypes.func.isRequired
};

export default PaginationContainer;


// WEBPACK FOOTER //
// ./src/Components/search/Features/Products/PaginationContainer.jsx